<script setup lang="ts">
    import dayjs from 'dayjs'
    import OrderHistoryItem from "./OrderHistoryItem.vue";
    import {computed} from "vue";

    interface  Item {
        type: 'call' | 'whatsapp' | 'ticket-open' | 'ticket-close' | 'status-update',
        content: string,
        time: string,
        id?: string | number
    }

    const props = withDefaults(defineProps<{
        day: string,
        items: Item[]
    }>(), {})

    const sortedItems = computed(() => {
        return [...props.items].sort((a, b) => {
            return a.time > b.time ? 1 : -1;
        })
    })
</script>

<template>
    <div class="order-history-day">
        <p class="order-history-heading">{{ dayjs(day).format('DD MMM YYYY') }}.</p>
        <order-history-item v-for="item in sortedItems" :item="item" />
    </div>
</template>

<style scoped lang="scss">
.order-history-day {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    .order-history-heading {
        @include font(1.6, 1.6, black);
        padding: 2rem;

        @include dark() {
            color: var(--color-white);
        }
    }
}
</style>
